import * as toastify from 'react-toastify';

import ToastContainer, { type ToastProps } from './ToastContainer';

type ToastOptions = {
  autoClose?: false | number;
  closeOnClick?: boolean;
  draggable?: boolean;
};

const toast = (data: ToastProps, options?: ToastOptions) =>
  toastify.toast(<ToastContainer />, {
    data,
    hideProgressBar: true,
    ...options,
  });
export default toast;
